import { Field, ErrorMessage } from 'formik';
import RegionalInstitutionPicker from './RegionalInstitutionPicker';
import LgpdModal from './LgpdModal';

export default function RegistrationFormFields({ slug, values, setFieldValue }) {
  return (
    <div className="space-y-4">
      <label className="block">
        <span className="text-sm font-medium">Nome completo *</span>
        <Field
          name="full_name"
          className="mt-1 w-full rounded border p-2"
        />
        <ErrorMessage
          name="full_name"
          component="span"
          className="text-sm text-red-600"
        />
      </label>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <label className="block">
          <span className="text-sm font-medium">CPF *</span>
          <Field
            name="cpf"
            className="mt-1 w-full rounded border p-2"
            placeholder="000.000.000-00"
          />
          <ErrorMessage
            name="cpf"
            component="span"
            className="text-sm text-red-600"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium">Data de nascimento *</span>
          <Field
            name="birth_date"
            type="date"
            className="mt-1 w-full rounded border p-2"
          />
          <ErrorMessage
            name="birth_date"
            component="span"
            className="text-sm text-red-600"
          />
        </label>
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <label className="block">
          <span className="text-sm font-medium">Email *</span>
          <Field
            name="email"
            type="email"
            className="mt-1 w-full rounded border p-2"
          />
          <ErrorMessage
            name="email"
            component="span"
            className="text-sm text-red-600"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium">Telefone/WhatsApp *</span>
          <Field
            name="phone"
            className="mt-1 w-full rounded border p-2"
            placeholder="(11) 9999-9999"
          />
          <ErrorMessage
            name="phone"
            component="span"
            className="text-sm text-red-600"
          />
        </label>
      </div>

      <RegionalInstitutionPicker
        slug={slug}
        regionalId={values.regional_id}
        institutionId={values.institution_id}
        onChange={patch => Object.entries(patch).forEach(([k, v]) => setFieldValue(k, v))}
      />

      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <label className="block">
          <span className="text-sm font-medium">Escolaridade atual *</span>
          <Field
            as="select"
            name="current_education_level"
            className="mt-1 w-full rounded border p-2"
          >
            <option value="">Selecione...</option>
            <option value="fundamental_2">Ensino Fundamental II</option>
            <option value="medio_1">1º Ano EM</option>
            <option value="medio_2">2º Ano EM</option>
            <option value="medio_3">3º Ano EM</option>
            <option value="concluido">EM Concluído</option>
            <option value="outro">Outro</option>
          </Field>
          <ErrorMessage
            name="current_education_level"
            component="span"
            className="text-sm text-red-600"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium">Série pretendida *</span>
          <Field
            name="desired_grade"
            className="mt-1 w-full rounded border p-2"
          />
          <ErrorMessage
            name="desired_grade"
            component="span"
            className="text-sm text-red-600"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium">Turno *</span>
          <Field
            as="select"
            name="preferred_shift"
            className="mt-1 w-full rounded border p-2"
          >
            <option value="">Selecione...</option>
            <option value="morning">Manhã</option>
            <option value="afternoon">Tarde</option>
            <option value="evening">Noite</option>
          </Field>
          <ErrorMessage
            name="preferred_shift"
            component="span"
            className="text-sm text-red-600"
          />
        </label>
      </div>

      <label className="flex items-start gap-2">
        <Field
          type="checkbox"
          name="special_needs"
          className="mt-1"
        />
        <span className="text-sm">Tenho alguma necessidade especial</span>
      </label>
      {values.special_needs && (
        <label className="block">
          <span className="text-sm font-medium">Descreva as necessidades</span>
          <Field
            as="textarea"
            name="special_needs_description"
            rows={3}
            className="mt-1 w-full rounded border p-2"
          />
          <ErrorMessage
            name="special_needs_description"
            component="span"
            className="text-sm text-red-600"
          />
        </label>
      )}

      <label className="flex items-start gap-2">
        <Field
          type="checkbox"
          name="lgpd_accepted"
          className="mt-1"
        />
        <span className="text-sm">
          Aceito o tratamento dos meus dados pessoais (<LgpdModal />)
        </span>
      </label>
      <ErrorMessage
        name="lgpd_accepted"
        component="span"
        className="text-sm text-red-600"
      />

      <div
        aria-hidden
        style={{ position: 'absolute', left: '-9999px' }}
      >
        <Field
          type="text"
          name="honeypot"
          tabIndex={-1}
          autoComplete="off"
        />
      </div>
    </div>
  );
}
